module.exports = __webpack_public_path__ + "img/withdraws-bg.8a2449b4.png";